let mainMenu = {
    init() {

        var ww = $(window).width();

        $('.menu-produit').appendTo('.block-otio-main-menu li.type-2');
        $('.menu-marque').appendTo('.block-otio-main-menu li.type-3');


        if(ww > 1024){
            $('.block-otio-main-menu li.type-2').hover(function() {
                $(this).find('.menu-produit').stop(true, true).delay(200).fadeIn(100);
            },function() {
                $(this).find('.menu-produit').stop(true, true).delay(200).slideUp(300);
            });

            $('.block-otio-main-menu li.type-3').hover(function() {
                $(this).find('.menu-marque').stop(true, true).delay(200).fadeIn(100);
            },function() {
                $(this).find('.menu-marque').stop(true, true).delay(200).slideUp(300);
            });

            $('header').hover(function() {
                $(this).addClass('active');
            },function() {
                $(this).removeClass('active');
            });
        }else{
            $(document).on('click', '.block-otio-main-menu li .icon-arrow-right', function () {
                if($(this).hasClass('active')){
                    $(this).removeClass('active');
                    $(this).parent().parent().find('.menu-content').slideUp(300);

                }else{
                    $('.block-otio-main-menu li .icon-arrow-right').removeClass('active');
                    $(this).addClass('active');
                    $('.block-otio-main-menu li .menu-content').slideUp(300);
                    $(this).parent().parent().find('.menu-content').slideDown(300);
                }
            });
        }


        $(document).on('click', '.burger-menu', function () {
           $(this).toggleClass('open');
           $('.header-content').slideToggle(300).css('display','flex');
        });


        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = window.innerHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`);

        // We listen to the resize event
        window.addEventListener('resize', () => {
            // We execute the same script as before
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        });

    }
}

export default mainMenu;
